import { $Q } from '../utils/querySelector';
import { IframYoutube } from './iframeYoutube';

class HeroHome {
  constructor() {
    this.heroHome = $Q('.js-hero-home');

    if (this.heroHome) {
      this._init();
    }
  }
  /**
   * Initialize Hero home functionalities
   */
  _init() {
    this.recoverHeaderHeight();
    this.initIframeYoutube();
  }

  /**
   * Add padding top to hero home element for simulate header height
   */
  recoverHeaderHeight() {
    $Q(
      '#js-hero-home-parent .hero-home__container',
      this.heroHome
    ).style.paddingTop = `${$Q('#header').offsetHeight}px`;
  }

  initIframeYoutube() {
    new IframYoutube();
  }
}

export { HeroHome };
